import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import Sparkline from '../../../components/Sparklines';

export const COLUMNS = (setCountry, country, t) => [
    {
        label: t('search.countries.module2.country'),
        key: 'country',
        data: 'country',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <button
                    className={`country-btn ${country === item.country ? 'active' : ''}`}
                    onClick={() => setCountry(item)}
                    style={{
                        background: 'unset',
                        border: 'none',
                    }}
                >
                    {data}
                </button>
            );
        },
    },
    {
        label: t('search.countries.module2.share'),
        key: 'share',
        data: 'share',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.00')}%</strong>;
        },
    },
    {
        label: t('search.countries.module2.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0a')}</strong>;
        },
    },
    {
        label: t('search.countries.module2.trend'),
        key: 'clicks_sparkline',
        data: 'clicks_sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';

            return (
                <Sparkline
                    dataL={item.clicksL}
                    keyName={t('search.countries.module2.clicks')}
                    labels={item.dateL.map((x) => x.value)}
                />
            );
        },
    },
    {
        label: t('search.countries.module2.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.countries.module2.position'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.countries.module2.ctr'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.clicks / item.impressions;
            return <strong>{numeral(item.clicks / item.impressions).format('0.00%')}</strong>;
        },
    },
];
